import { useState } from "react";
import { useContent, useWa, rich } from "@/lib/content";
import { Reveal, SectionTitle, WhatsIcon } from "./Primitives";
import { Lightbox } from "./Lightbox";


export const Galeria = ({ id = "galeria", dataKey = "GALLERY", prefix = "gal", cta = null }) => {
  const [open, setOpen] = useState(null);
  const content = useContent();
  const waLink = useWa();
  const T = content.TEXTS;
  const items = Array.isArray(content[dataKey]) ? content[dataKey] : [];
  const tid = id === "galeria" ? "gallery" : id;
  const IMAGES = items.map((g) => ({ src: g.img, cap: g.cap }));
  const intro = T[`${prefix}_intro`];
  const ctaBtn = cta && (
    <Reveal className="mt-10">
      <a
        data-testid={`${id}-whatsapp-cta`}
        href={waLink(cta.msg)}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-2 rounded-full border border-gold px-7 py-4 font-sans text-sm text-cream transition-colors hover:bg-gold hover:text-espresso"
      >
        <WhatsIcon className="h-4 w-4" /> {T[cta.label]}
      </a>
    </Reveal>
  );
  const single = intro && items.length === 1;
  const grid = (
    <div className={single ? "mx-auto w-full max-w-[280px] sm:max-w-sm md:ml-auto md:mr-0 md:max-w-[460px]" : `grid auto-rows-[130px] grid-flow-dense grid-cols-2 gap-3 sm:auto-rows-[180px] sm:gap-4 md:auto-rows-[230px] ${intro ? "" : "md:grid-cols-4"}`}>
        {items.map((g, i) => (
          <Reveal key={`${g.img}-${i}`} delay={(i % 4) * 0.08} className={single ? "" : `${g.span} h-full`}>
            <button data-testid={`${tid}-item-${i}`} onClick={() => setOpen(i)} className="group relative h-full w-full overflow-hidden rounded-2xl border border-gold/15">
              <img src={g.img} alt={g.cap} loading="lazy" className={`${single ? "h-auto" : "h-full"} w-full object-cover transition-transform duration-[1.2s] group-hover:scale-110`} />
              <div className="absolute inset-0 bg-gradient-to-t from-espresso/85 via-espresso/0 to-transparent transition-opacity duration-500 md:opacity-0 md:group-hover:opacity-100" />
              <span data-testid={`${tid}-caption-${i}`} className="absolute bottom-3 left-3 right-3 text-left font-display text-base italic leading-tight text-cream transition-[opacity,transform] duration-500 md:bottom-5 md:left-5 md:translate-y-2 md:text-xl md:opacity-0 md:group-hover:translate-y-0 md:group-hover:opacity-100">
                {g.cap}
              </span>
            </button>
          </Reveal>
        ))}
      </div>
  );

  return (
    <section id={id} data-testid={`${id}-section`} className="mx-auto max-w-[1400px] px-5 py-20 md:px-10 md:py-28 lg:py-40">
      <SectionTitle className="mb-14" eyebrow={T[`${prefix}_eyebrow`]} title={rich(T[`${prefix}_title`])} de={T[`${prefix}_de`]} testid={`${id}-title`} />
      {intro ? (
        <div className="grid items-center gap-10 md:grid-cols-2 md:gap-16">
          <Reveal data-testid={`${id}-intro`}>
            {T[`${prefix}_intro_title`] && <p className="font-display text-3xl italic text-gold md:text-4xl">{T[`${prefix}_intro_title`]}</p>}
            <p className="mt-4 max-w-lg font-sans text-base leading-relaxed text-sand md:text-lg">{intro}</p>
            {ctaBtn}
          </Reveal>
          {grid}
        </div>
      ) : (
        <>
          {grid}
          {ctaBtn}
        </>
      )}
      <Lightbox images={IMAGES} index={open} onChange={setOpen} onClose={() => setOpen(null)} />
    </section>
  );
};
